import ValidationTestsPage from './validation-tests-page';

export default ValidationTestsPage;